import { render, staticRenderFns } from "./StatsCardBreakdown.vue?vue&type=template&id=282b5f40&scoped=true&"
import script from "./StatsCardBreakdown.vue?vue&type=script&lang=js&"
export * from "./StatsCardBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./StatsCardBreakdown.vue?vue&type=style&index=0&id=282b5f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b5f40",
  null
  
)

export default component.exports